export default {"src":"/_next/static/media/logo.67709fef.svg","height":24,"width":24};